import { render, staticRenderFns } from "./BipSchoolsModeling.vue?vue&type=template&id=6b6c79ee&scoped=true&"
import script from "./BipSchoolsModeling.vue?vue&type=script&lang=js&"
export * from "./BipSchoolsModeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c79ee",
  null
  
)

export default component.exports